module.exports = __webpack_public_path__ + "img/juice.be5030ca.webp";